module.exports = __webpack_public_path__ + "static/img/banner3.e6b4101.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners_new/banner3.png
// module id = 6D4v
// module chunks = 6